module.exports = __webpack_public_path__ + "img/img15.a9310358.svg";